import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=d8cab7d6&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports